// src/components/AQSenseTeaser.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

export default function AQSenseTeaser() {
  const navigate = useNavigate();

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 grid md:grid-cols-2 gap-10 items-center">
        
        {/* LEFT — CONTENT */}
        <div>
          <span className="inline-block mb-3 px-3 py-1 text-xs font-semibold rounded-full bg-yellow-100 text-yellow-800">
            Launching Soon
          </span>

          <h2 className="text-3xl font-bold mb-4">
            AERZEN AIR™ AQ Sense
          </h2>

          <p className="text-gray-700 mb-6">
            A smart air quality monitor that shows real-time PM2.5, PM10,
            and AQI levels — helping you see the difference your purifier makes.
          </p>

          <button
            onClick={() => navigate("/aq-sense")}
            className="text-blue-600 underline font-medium"
          >
            Learn more →
          </button>
        </div>

        {/* RIGHT — PRODUCT TEASER IMAGE */}
        <div className="bg-gray-100 rounded-2xl p-4 flex items-center justify-center">
          <img
            src="/images/aq-sense/teaser.jpg"
            alt="AERZEN AIR™ AQ Sense – Product Teaser"
            className="w-full max-w-md object-contain"
          />
        </div>

      </div>
    </section>
  );
}
